const breakpoints = {
    breakpoints: {
        base: '0px',
        sm: '376px',
        md: '768px',
        lg: '1024px',
        xl: '1280px',
        '2xl': '1440px',
    },
}
export default breakpoints
